import styled from 'styled-components';

export const LoyaltyBannerOne = styled.img`
  display: block;
  margin: 1em auto;
  width: 100%;
  height: auto;
`;
